// @ts-ignore
import { ElNotification } from "element-plus";
import XlsExport from "xlsexport/xls-export";
import { saveBlobWithSavePicker } from "~/apis/requests/useApiCall";

export async function exportToExcel<T>(data: T[], title: string) {
  if (data.length === 0) {
    ElNotification({
      type: "info",
      message: "No data to export",
      title: "Empty",
    });
    return;
  }
  const exportedData = data.map(stringifyValue<T>);
  const xls = new XlsExport(exportedData, title);
  const timestamp = Date.now();

  let objectUrl = "";
  xls.downloadFile = (url: string) => {
    objectUrl = url;
  };
  xls.exportToXLS(`${title}_${timestamp}`);

  const blob = await fetch(objectUrl).then((res) => res.blob());
  window.URL.revokeObjectURL(objectUrl);

  await saveBlobWithSavePicker(blob, `${title}_${timestamp}`, ".xls");
}

function stringifyValue<T>(item: T) {
  const res = {};
  // @ts-ignore
  for (const [key, value] of Object.entries(item)) {
    // @ts-ignore
    res[key] = JSON.stringify(value);
  }
  return res;
}

export function formatTimeDiffForHumans(dateString: Date) {
  const date: any = new Date(dateString);
  const now: any = new Date();

  const diffInSeconds = Math.floor((now - date) / 1000);

  if (diffInSeconds < 60) {
    return "Just now";
  } else if (diffInSeconds < 3600) {
    const minutes = Math.floor(diffInSeconds / 60);
    return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
  } else if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);
    return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  } else {
    const days = Math.floor(diffInSeconds / 86400);
    return `${days} day${days > 1 ? "s" : ""} ago`;
  }
}

export function formatFilterDateTime(dateTime: Date) {
  const year = dateTime.getFullYear();
  const month = String(dateTime.getMonth() + 1).padStart(2, "0");
  const day = String(dateTime.getDate()).padStart(2, "0");
  const hours = String(dateTime.getHours()).padStart(2, "0");
  const minutes = String(dateTime.getMinutes()).padStart(2, "0");
  const seconds = String(dateTime.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function formatFilterDate(dateTime: Date) {
  const year = dateTime.getFullYear();
  const month = String(dateTime.getMonth() + 1).padStart(2, "0");
  const day = String(dateTime.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function formatJsonDataForTable(data: string) {
  // data = JSON.parse(data);
  // return data;
  // console.log(data);
  let strVal = "";
  for (const [key, val] of Object.entries(data)) {
    strVal += `${key} : ${val} \n`;
  }
  return strVal;
}

export function snakeToTitleCase(input: string | null) {
  if (!input) return input;

  const words = input.split("_");

  const titleCaseWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1),
  );

  const titleCaseString = titleCaseWords.join(" ");

  return titleCaseString;
}
